import styled from 'styled-components';

import BodyText from './BodyText';

const HeadlineText = styled(BodyText)`
  font-weight: 700;
`;

export default HeadlineText;
